<template>
  <div class="rt-portal-list">
    <rt-sass-grid
      ref="grid"
      iconName="rt-portal-order-form"
      :title="$_t('签核处理', 'approval.flowapproval')"
      :quicksearch-placeholder="$_t('请输入单号', 'common.plsenterno')"
      :totalRecord="dataTotalCount"
      :currentPageIndex="currentPageIndex"
      :currentPageSize="currentPageSize"
      @page-change="handlePageChange"
      @quick-search="handleSearch"
      @search="handleSearch"
      @reset="handleReset"
    >
      <template slot="more">
        <el-form
          :model="queryForm"
          ref="queryForm"
          label-position="left"
          label-width="120px"
        >
          <el-row :gutter="40" type="flex">
            <el-col :span="8">
              <el-form-item
                :label="$_t('申请人', 'new_flowapprovalcrf.new_applyuser')"
                prop="submitUser"
              >
                <el-input
                  v-model="queryForm.submitUser"
                  :placeholder="
                    $_t('申请人', 'new_flowapprovalcrf.new_applyuser')
                  "
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$_t('部门管理', 'crm.businessunit')"
                prop="businessName"
              >
                <el-input
                  v-model="queryForm.businessName"
                  :placeholder="$_t('部门管理', 'crm.businessunit')"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$_t('摘要', 'new_flowapprovalcrf.new_memo')"
                prop="memo"
              >
                <el-input
                  v-model="queryForm.memo"
                  :placeholder="$_t('摘要', 'new_flowapprovalcrf.new_memo')"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40" type="flex">
            <!-- 摘要 -->

            <el-col
              :span="8"
              v-if="activeName == 'first' || activeName == 'first_reject'"
            >
              <el-form-item
                :label="$_t('申请时间', 'new_flowapprovalcrf.new_applydate')"
                prop="applyDate"
              >
                <el-date-picker
                  class="rt-portal-item-date"
                  v-model="queryForm.applyDate"
                  format="yyyy/MM/dd"
                  :start-placeholder="$_t('开始日期', 'daterange.begindate')"
                  :end-placeholder="$_t('结束日期', 'daterange.enddate')"
                  type="daterange"
                  @change="applydatechange"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="activeName == 'second'">
              <el-form-item
                :label="
                  $_t('签核时间',
                  'new_flowapproval_steps.new_approvedate')
                "
                prop="approveDate"
              >
                <el-date-picker
                  class="rt-portal-item-date"
                  v-model="queryForm.approveDate"
                  format="yyyy/MM/dd"
                  :placeholder="
                    $_t('签核时间',
                    'new_flowapproval_steps.new_approvedate')
                  "
                  type="date"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="activeName == 'second'">
              <el-form-item
                :label="
                  $_t('签核结果',
                  'new_flowapproval_steps.new_actiontypename')
                "
                prop="actionType"
              >
                <picklistcomponent
                  v-bind:optionModel="actionTypeOption"
                  v-bind:selected="selectedActionType"
                  @selectitem="selectActionType"
                >
                </picklistcomponent>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
      <el-tabs v-model="activeName" @tab-click="handleClick" ref="user">
        <el-tab-pane name="first" :key="inApprovedCount + '_first'">
          <span slot="label">
            <b v-if="inApprovedCount > 0" class="tabs_num">{{
              inApprovedCount
            }}</b>
            {{ $_t("待我审批", "approval.approving") }}
          </span>
          <el-table
            ref="gridTable"
            :data="tableData"
            stripe
            tooltip-effect="dark"
            v-loading="loading"
            @row-dblclick="handleViewDetail"
            @sort-change="sortChange"
            v-if="activeName == 'first'"
          >
            <el-table-column
              :label="$_t('表单编号', 'new_flowapprovalcrf.new_formname')"
              prop="new_formname"
              min-width="150"
            >
              <template slot-scope="scope">
                <span class="worknum" @click="handleViewDetail(scope.row)">{{
                  scope.row.new_formname
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="new_flowidName"
              :label="$_t('签核流程', 'new_flowapprovalcrf.new_flowidname')"
            >
            </el-table-column>
            <el-table-column
              prop="new_approveuserName"
              :label="$_t('签核用户', 'new_flowapprovalcrf.owneridname')"
            >
            </el-table-column>
            <el-table-column
              prop="new_memo"
              width="200"
              :label="$_t('摘要', 'new_flowapprovalcrf.new_memo')"
            ></el-table-column>
            <el-table-column
              prop="new_applyuserName"
              :label="$_t('申请人', 'new_flowapprovalcrf.new_applyuser')"
            >
            </el-table-column>
            <el-table-column
              prop="businessunitName"
              :label="$_t('部门管理', 'crm.businessunit')"
              min-width="120"
            >
            </el-table-column>
            <el-table-column
              prop="new_applydate"
              :label="$_t('申请时间', 'new_flowapprovalcrf.new_applydate')"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="new_last_approve_time"
              width="160"
              :label="
                $_t(
                  '上一步审批时间',
                  'new_flowapprovalcrf.new_last_approve_time'
                )
              "
            ></el-table-column>
            <el-table-column
              :label="$_t('操作', 'common.operations')"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="handleViewDetail(scope.row)">
                  {{ $_t("去审批", "approval.doapproval") }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane name="second" :key="ApprovedCount + '_second'">
          <span slot="label">
            <b v-if="ApprovedCount > 0" class="tabs_num_success">{{
              ApprovedCount
            }}</b>
            {{ $_t("我已审批", "approval.approved") }}
          </span>
          <el-table
            ref="gridTable"
            :data="tableData"
            tooltip-effect="dark"
            v-loading="loading"
            @row-dblclick="handleViewDetail"
            @sort-change="sortChange"
            v-if="activeName == 'second'"
          >
            <el-table-column
              :label="$_t('表单编号', 'new_flowapprovalcrf.new_formname')"
              prop="new_formname"
              min-width="150"
            >
              <template slot-scope="scope">
                <span class="worknum" @click="handleViewDetail(scope.row)">{{
                  scope.row.new_formname
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="new_flowidName"
              align="center"
              :label="$_t('签核流程', 'new_flowapprovalcrf.new_flowidname')"
              min-width="160"
            ></el-table-column>
            <el-table-column
              prop="new_approveuserName"
              align="center"
              :label="$_t('签核用户', 'new_flowapprovalcrf.owneridname')"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="new_approvedate"
              align="center"
              :label="$_t('签核时间', 'new_flowapproval_steps.new_approvedate')"
              min-width="150"
            ></el-table-column>
            <el-table-column
              prop="new_actiontypeName"
              align="center"
              :label="
                $_t('签核结果',
                'new_flowapproval_steps.new_actiontypename')
              "
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="new_applyuserName"
              align="center"
              :label="$_t('申请人', 'new_flowapprovalcrf.new_applyuser')"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="new_memo"
              width="200"
              :label="$_t('摘要', 'new_flowapprovalcrf.new_memo')"
            ></el-table-column>
            <el-table-column
              prop="businessunitName"
              :label="$_t('部门管理', 'crm.businessunit')"
              min-width="120"
            >
            </el-table-column>
            <el-table-column
              :label="$_t('操作', 'common.operations')"
              min-width="100"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="handleViewDetail(scope.row)">
                  {{ $_t("审批详情", "approval.approvaldetail") }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane name="three" :key="NotifyCount + '_three'">
          <span slot="label">
            <b v-if="NotifyCount > 0" class="tabs_num tabs_num3">{{
              NotifyCount
            }}</b>
            {{ $_t("知会我的", "approval.notify") }}
          </span>
          <el-table
            ref="gridTable"
            :data="tableData"
            tooltip-effect="dark"
            v-loading="loading"
            @row-dblclick="handleViewDetail"
            @sort-change="sortChange"
            v-if="activeName == 'three'"
          >
            <el-table-column
              :label="$_t('表单编号', 'new_flowapprovalcrf.new_formname')"
              prop="new_formname"
              min-width="150"
            >
              <template slot-scope="scope">
                <span class="worknum" @click="handleViewDetail(scope.row)">{{
                  scope.row.new_formname
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="new_flowidName"
              :label="$_t('签核流程', 'new_flowapprovalcrf.new_flowidname')"
            >
            </el-table-column>
            <el-table-column
              prop="new_applyuserName"
              :label="$_t('申请人', 'new_flowapprovalcrf.new_applyuser')"
            >
            </el-table-column>
            <el-table-column
              prop="businessunitName"
              :label="$_t('部门管理', 'crm.businessunit')"
              min-width="120"
            >
            </el-table-column>
            <el-table-column
              prop="new_memo"
              width="200"
              :label="$_t('摘要', 'new_flowapprovalcrf.new_memo')"
            ></el-table-column>
            <el-table-column
              prop="new_applydate"
              :label="$_t('申请时间', 'new_flowapprovalcrf.new_applydate')"
            >
            </el-table-column>
            <el-table-column
              prop="new_approvalstatusName"
              :label="$_t('审批状态', 'new_flowapproval_steps.new_statusname')"
            ></el-table-column>
            <el-table-column
              :label="$_t('操作', 'common.operations')"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="handleViewDetail(scope.row)">
                  {{ $_t("审批详情", "approval.approvaldetail") }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </rt-sass-grid>
  </div>
</template>

<script>
import picklistcomponent from "./picklist-component.vue";
export default {
  data() {
    return {
      queryForm: {
        entityName: "",
        submitUser: "",
        memo: "",
        approveDate: "",
        applyDate: "",
        actionType: "",
        businessName: "",
        lastApproveTime: "",
      },
      loading: false,
      orderby: {
        attribute: "new_applydate",
        descending: true,
      },
      dataTotalCount: 0,
      tableData: [],
      pageCookie: "",
      isneedCookie: false,
      activeName: "first",
      entityOptions: [],
      inApprovedCount: 0,
      inRejectApproveCount: 0,
      ApprovedCount: 0,
      NotifyCount: 0,
      entityName: "",
      actionTypeOption: [
        {
          value: 1,
          text: "common.agree", //"同意"
          name:'同意'
        },
        {
          value: 2,
          text: "common.reject", //"驳回"
          name:'驳回'
        },
      ],
      selectedActionType: "",
      currentPageIndex: 1,
      currentPageSize: 10,
    };
  },
  components: {
    picklistcomponent,
  },
  mounted() {
    this.$nextTick(() => {
      this.search();
    });
  },
  watch: {
    "queryForm.submitUser"(val) {
      this.$refs.grid.resetPageIndex();
      // this.currentPageIndex=1
    },
    "queryForm.businessName"(val) {
      this.$refs.grid.resetPageIndex();
      // this.currentPageIndex=1
    },
    "queryForm.approveDate"(val) {
      this.$refs.grid.resetPageIndex();
      // this.currentPageIndex=1
    },
    "queryForm.lastApproveTime"(val) {
      this.$refs.grid.resetPageIndex();
      // this.currentPageIndex=1
    },
    "queryForm.actionType"(val) {
      this.$refs.grid.resetPageIndex();
      // this.currentPageIndex=1
    },
  },
  methods: {
    applydatechange() {
      this.$refs.grid.resetPageIndex();
      // this.currentPageIndex=1
    },
    lastApproveDatechange() {
      this.$refs.grid.resetPageIndex();
      // this.currentPageIndex=1
    },
    selectActionType: function (val) {
      this.selectedActionType = val;
      this.queryForm.actionType = val;
      this.$refs.grid.resetPageIndex();
    },
    //查询条件
    getfilter() {
      var filterStr = "";
      //单号
      if (this.$refs.grid.quickSearch !== null) {
        filterStr += "formName=" + this.$refs.grid.quickSearch + "&";
      } else {
        filterStr += "formName=&";
      }
      //申请人
      filterStr += "submitUser=" + this.queryForm.submitUser + "&";
      //摘要
      filterStr += "memo=" + this.queryForm.memo + "&";
      //部门
      filterStr += "businessunitName=" + this.queryForm.businessName + "&";
      //签核日期
      if (this.queryForm.approveDate) {
        filterStr +=
          "approveDate=" +
          rt.formatDateTime(this.queryForm.approveDate, "yyyy-mm-dd") +
          "&";
      }
      //上一步审批时间
      if (
        this.queryForm.lastApproveTime &&
        this.queryForm.lastApproveTime.length > 1
      ) {
        filterStr +=
          "lastApproveTime=" +
          JSON.stringify([
            rt.formatDateTime(this.queryForm.lastApproveTime[0], "yyyy-mm-dd"),
            rt.formatDateTime(this.queryForm.lastApproveTime[1], "yyyy-mm-dd"),
          ]) +
          "&";
      }
      //申请日期
      if (this.queryForm.applyDate && this.queryForm.applyDate.length > 1) {
        filterStr +=
          "applyDate=" +
          JSON.stringify([
            rt.formatDateTime(this.queryForm.applyDate[0], "yyyy-mm-dd"),
            rt.formatDateTime(this.queryForm.applyDate[1], "yyyy-mm-dd"),
          ]) +
          "&";
      }
      //签核结果
      //filterStr += "actionType=" + this.queryForm.actionType + "&";
      if (filterStr.length > 0) {
        return "&" + filterStr.substring(filterStr, filterStr.length - 1);
      }
      return "";
    },
    //重置
    handleReset() {
      this.$refs["queryForm"].resetFields();
      // for (var key in this.queryForm) {
      //     this.$set(this.queryForm, key, '');
      // }
      this.selectedActionType = "";
      this.$refs.grid.setSearchString("");
      this.search();
    },
    handlePageChange() {
      this.search();
    },
    handleSearch() {
      this.search();
    },
    //查询
    search() {
      this.$nextTick(() => {
        if (this.activeName == "first") {
          this.getdata(1);
        } else if (this.activeName == "first_reject") {
          this.getdata(2);
        } else if (this.activeName == "second") {
          this.getmyapprovedlist();
        } else if (this.activeName == "three") {
          this.GetMyNotifyList();
        } else {
          this.getdata(0);
        }
      });
    },

    handleClick(tab, event) {
      this.currentPageIndex = 1;
      this.activeName = tab.name;
      this.$refs.grid.resetPageIndex();
      this.search();
    },
    //获取待审核列表
    getdata(queryType) {
      var pageIndex = this.$refs.grid.getPageIndex();
      var pageSize = this.$refs.grid.getPageSize();
      var url = "api/CrmFlow/GetFlowInApproveList";
      let apiUrl =
        url +
        "?flowid=" +
        this.queryForm.entityName +
        this.getfilter() +
        "&orderby=" +
        JSON.stringify(this.orderby) +
        "&pageIndex=" +
        pageIndex +
        "&pageSize=" +
        pageSize +
        "&queryType=" +
        queryType;
      this.isneedCookie = false;
      this.loading = true;
      let that = this;
      rt.get(apiUrl)
        .then((res) => {
          that.inApprovedCount = res.InApprovedCount;
          that.inRejectApproveCount = res.InRejectApproveCount;
          that.ApprovedCount = res.ApprovedCount;
          that.NotifyCount = res.NotifyCount;
          that.tableData = res.InApproveList;
          that.dataTotalCount =res.TotalRecordCount;
          that.loading = false;
        })
        .catch((error) => {
          rt.showErrorToast(error);
          that.loading = false;
        });
    },
    // 获取已审核列表
    getmyapprovedlist() {
      var pageIndex = this.$refs.grid.getPageIndex();
      var pageSize = this.$refs.grid.getPageSize();
      var url = "api/CrmFlow/GetFlowApprovedList";
      let apiUrl =
        url +
        "?flowid=" +
        this.queryForm.entityName +
        this.getfilter() +
        "&orderby=" +
        JSON.stringify(this.orderby) +
        "&pageIndex=" +
        pageIndex +
        "&pageSize=" +
        pageSize;
      this.isneedCookie = false;
      this.loading = true;
      let that = this;
      rt.get(apiUrl)
        .then((res) => {
          that.inApprovedCount = res.InApprovedCount;
          that.ApprovedCount = res.ApprovedCount;
          that.NotifyCount = res.NotifyCount;
          that.tableData = res.ApprovedList;
          that.dataTotalCount = res.TotalRecordCount;
          that.loading = false;
        })
        .catch((error) => {
          rt.showErrorToast(error);
          that.loading = false;
        });
    },
    //获取只会我的列表
    GetMyNotifyList() {
      var url = "api/CrmFlow/GetFlowNotifyList";
      var pageIndex = this.$refs.grid.getPageIndex();
      var pageSize = this.$refs.grid.getPageSize();
      this.loading = true;
      let apiUrl =
        url +
        "?flowid=" +
        this.queryForm.entityName +
        this.getfilter() +
        "&orderby=" +
        JSON.stringify(this.orderby) +
        "&pageIndex=" +
        pageIndex +
        "&pageSize=" +
        pageSize;
      this.isneedCookie = false;
      let that = this;
      rt.get(apiUrl)
        .then((res) => {
          that.inApprovedCount = res.InApprovedCount;
          that.ApprovedCount = res.ApprovedCount;
          that.NotifyCount = res.NotifyCount;
          that.tableData = res.NotifyList;
          that.dataTotalCount = res.TotalRecordCount;
          that.loading = false;
          that.$children[0].$children[0].$forceUpdate();
        })
        .catch((error) => {
          rt.showErrorToast(error);
          that.loading = false;
        });
    },
    //单号跳转
    orderNumberClick(row) {
      var routerInfo = this.referenceRouteDetail(row.new_formid);
      if (!routerInfo) {
        this.handleViewDetail(row);
        return;
      }
      var params = {
        id: row.new_formid,
      };
      if (row.new_typecode === "new_srv_workorder_changeapply") {
        params.etn = row.new_typecode;
      } else if (routerInfo == "VForm") {
        params.entityName = row.new_typecode;
      } else if (routerInfo.indexOf(":") != -1) {
        var routerArray = routerInfo.split(":");
        if (!routerArray[0] || !routerArray[1]) {
          rt.showErrorToast(
            "new_form_router is error,example:VForm:LogicalName"
          );
          return;
        } else if (routerArray[0] != "VForm") {
          rt.showErrorToast(
            "new_form_router is error,example:VForm:LogicalName"
          );
          return;
        }
        var formLogicalName = routerArray[1];
        this.$router.push({
          path: `/vform3/${row.new_typecode}/${formLogicalName}/${row.new_formid}`,
        });
        return;
      }
      this.$router.push({
        name: routerInfo,
        params: params,
      });
    },
    //双击或去审批按钮跳转
    handleViewDetail(row) {

      //拿到后台配置的routername，导向新页面加载页面详情
      var routerInfo = this.referenceRouteDetail(row.new_formid);
      if (!routerInfo) {
        //没有配置路由的话 跳转另一个
        this.handleView(row);
        return;
      }
      console.log("输出去审批：",row);
      let _params = {
        id: row.new_formid,
        etn: row.new_typecode,
        routerinfo: routerInfo,
        iscommunicate: row["new_is_communicate"] == true ? 1 : 0,
      };
      if (
        row.new_flowapproval_stepsid != null &&
        row.new_flowapproval_stepsid.length > 0
      ) {
        _params.stepid = row.new_flowapproval_stepsid;
      }
      if (this.activeName == "first" || this.activeName == "first_reject") {
        _params.isshowapproval = true;
      } else {
        _params.isshowapproval = false;
      }
      this.$router.push({
        name: "ApproveCenter",
        params: _params,
      });
    },
    //查看签核流程
    handleView(row) {
      console.log("输出去审批签核流程：",row);
      var _params = {
        id: row.new_formid,
        etn: row.new_typecode,
        iscommunicate: row["new_is_communicate"] == true ? 1 : 0,
      };
      if (
        row.new_flowapproval_stepsid != null &&
        row.new_flowapproval_stepsid.length > 0
      ) {
        _params.stepid = row.new_flowapproval_stepsid;
      }
      this.$router.push({
        name: "Approve",
        params: _params,
        target: "_blank",
      });
    },
    //排序处理
    sortChange(val) {
      if (!val.prop) {
        return;
      }
      if (this.orderby.attribute === val.prop) {
        this.orderby.descending = !this.orderby.descending;
      } else {
        this.orderby.attribute = val.prop;
        this.orderby.descending = true;
      }
      this.tableData = [];
      this.search();
    },
    //签核流程变化
    handleChange(val) {
      if (this.entityOptions && this.entityOptions.length > 0 && val) {
        var result = this.entityOptions.filter((item) => item.value == val);
        this.entityName = result[0].Etn;
      } else {
        this.entityName = "";
      }
    },
    //通过审批信息中的实体找出表单名称
    referenceRouteDetail(ent) {
  
      if (!ent) {
        return null;
      }
      if (this.entityOptions && this.entityOptions.length > 0) {
        var flow = this.entityOptions.filter((e) => e.value == ent);
        if (flow.length === 0) {
          return null;
        }
        return flow[0].new_form_router;
      } else {
        return null;
      }
    },
    //列表缓存
    getCachingDataForPush() {
      return {
        queryForm: this.queryForm,
        quickSearch: this.$refs.grid.quickSearch,
        activeName: this.activeName,
        pageIndex: this.$refs.grid.getPageIndex(),
        pageSize: this.$refs.grid.getPageSize(),
      };
    },
    //列表缓存，接受缓存的数据
    resetCachedDataForGoback(data) {
      if (data) {
        this.$nextTick(() => {
          this.queryForm = data.queryForm;
          this.$refs.grid.setSearchString(data.quickSearch);
          this.activeName = data.activeName;
          this.selectActionType(data.queryForm.actionType);
          this.currentPageIndex = data.pageIndex;
          this.currentPageSize = data.pageSize;
        });
      }
    },
  },
};
</script>

<style scoped>
.rt-portal-list{
  padding-top: 65px;
  height: calc(100% - 34px);
}
.rt-portal-list .rt-sass-grid{
  height: 100%;
}
.el-table >>> .el-table__empty-block{
  height: calc(100% - 440px)!important;
}
.tabs_num {
  position: absolute;
  right: 0;
  top: -8px;
  background-color: #f56c6c;
  border-radius: 10px;
  color: #ffffff;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #ffffff;
}
.tabs_num3 {
  right: -21px;
}

.tabs_num_success {
  position: absolute;
  right: 0;
  top: -8px;
  background: #e5f2ff;
  color: #0072e6;
  border-radius: 10px;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #ffffff;
}
</style>



// WEBPACK FOOTER //
// ApproveList.vue?ffc1d5c4